import Base from './base.entity';

type EntityLists = { [entityName: string]: Array<Base> };

export interface SosListResponse {
	listed: EntityLists;
}

export type SosGetResponse = SosListResponse;

export interface SosCreateResponse {
	created: EntityLists;
}

export interface SosUpdateResponse {
	updated: EntityLists;
}

export interface SosDeleteResponse {
	destroyed: EntityLists;
}
